import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty, removeByIndex } from 'Utils'
import { FormElemGroup } from 'Components/Form'
import RecipientInput from './components/RecipientInput'

import { _MoreBtn } from './styles'

const emptyRecipient = { recipient: '', completed: false }
const getRecipient = (rec) => rec.recipient
const emptyFunc = () => {}
const AddRecipientMulti = (
  {
    initCcList, onRecipientChange = emptyFunc,
    marginBottomMag = 2, className,
  }) => {
  const [recipients, updateRecipients] = useState([])
  const [addEnabled, updateAddState] = useState(false)
  useEffect(() => {
    if(!initCcList || isNilEmpty(initCcList)) {
      return updateRecipients([])
    }
    const newRecipients = initCcList.split(',').map(email => ({ recipient: email, completed: true }))
    updateRecipients(newRecipients)
  }, [initCcList])


  function onDelete(index, onlyUpdateLocal) {
    updateRecipients(prevState => {
      updateAddState(false)
      if(prevState.length > 1) {
        const newRecipients = removeByIndex(prevState, index)
        const recipientsOnly = newRecipients.map(getRecipient)
        onRecipientChange(recipientsOnly)
        return newRecipients
      }
      if(onlyUpdateLocal) {
        updateRecipients([])
      } else {
        onRecipientChange([])
      }
      return []
    })
  }
  function onAdd(index, recipient) {
    updateRecipients(prevState => {
      const newRecipient = [...prevState]
      newRecipient[index] = {
        recipient,
        completed: true,
      }
      const recipientsOnly = newRecipient.map(getRecipient)
      onRecipientChange(recipientsOnly)
      return [...newRecipient]
    })
    updateAddState(false)
  }
  function moreRecipientClick(e) {
    e.preventDefault()
    if(addEnabled) return null
    updateRecipients(prevState => [...prevState, emptyRecipient])
    updateAddState(true)
  }

  return (
    <div className={className || ''}>
      {
        recipients && recipients.map((recipient, index) => (
          <FormElemGroup key={recipient.recipient} marginBottomMag={marginBottomMag}>
            <RecipientInput
              data-test-id="recipientInput"
              // eslint-disable-next-line
              key={recipient.recipient + index}
              value={recipient.recipient}
              index={index}
              onAdd={onAdd}
              onDelete={onDelete}
              showDelete={recipient.completed}
            />
          </FormElemGroup>
        ))
      }
      {/* show when add button click || initRecipient.length > 0 */}
      <_MoreBtn
        addEnabled={addEnabled}
        data-test-id="moreBtn"
        onClick={moreRecipientClick}
      >
        + {recipients && recipients.length > 0 ? 'More' : 'Another'} Recipient
      </_MoreBtn>
    </div>
  )
}
AddRecipientMulti.propTypes = {
  onRecipientChange: PropTypes.func,
  initCcList: PropTypes.string,
  className: PropTypes.string,
  marginBottomMag: PropTypes.number,
}
export default AddRecipientMulti
